import { MAGIC_NUMBERS } from './constants';
import { KEYS } from './keys';

const smakaSearchContainer = document.querySelector(
  '#js-smaka-search-container',
);

const searchResultList = document.querySelector(
  '#js-smaka-incremental-searchresults',
);

let input;

const shiftFocus = moveUp => {
  var items = Array.from(
    smakaSearchContainer.querySelectorAll('a, input[type="text"]'),
  );
  var curIndex = items.indexOf(document.activeElement);
  if (moveUp) {
    if (curIndex > 0) {
      items[curIndex - 1].focus();
    }
  } else if (curIndex + 1 < items.length) {
    items[curIndex + 1].focus();
  }
};

export function init() {
  input = document.querySelector(
    '#js-smaka-search-container input[type="text"]',
  );
  if (!input) {
    return;
  }

  smakaSearchContainer.addEventListener('keydown', event => {
    switch (event.key) {
      case KEYS.ESCAPE:
        updateResultList('');
        break;
      case KEYS.ARROW_DOWN:
        event.preventDefault();
        shiftFocus(false);
        break;
      case KEYS.ARROW_UP:
        event.preventDefault();
        shiftFocus(true);
        break;
    }
  });

  input.addEventListener('input', event => {
    doSearch(event.target.value);
  });

  smakaSearchContainer.addEventListener('focusout', event => {
    if (!smakaSearchContainer.contains(event.relatedTarget)) {
      updateResultList('');
    }
  });
}

const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};

const doSearch = debounce(query => {
  fetch('/smaka/IncrementalSearch/?q=' + query)
    .then(response => response.text())
    .then(data => updateResultList(data));
}, MAGIC_NUMBERS.DEBOUNCE_INTERVAL);

const updateResultList = data => {
  if (data.trim().length > 0) {
    searchResultList.classList.remove('d-none');
    input.setAttribute('aria-expanded', 'true');
  } else {
    searchResultList.classList.add('d-none');
    input.setAttribute('aria-expanded', 'false');
  }
  searchResultList.innerHTML = data;
};
